import Vue from 'vue';
import Router from 'vue-router';
import Editor from '@/components/Editor';
import Page404 from '@/components/404';
import AddScreen from '@/components/AddScreen';
//import Template from '@/components/AppPrograms/Template';
import ListSegment from '../components/AppSegment/ListSegment.vue';
import EditSegment from '../components/AppSegment/EditSegment.vue';
import Schedule from '../components/AppSchedule/Schedule.vue'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/display/',
      name: 'Page404',
      component: Page404,
    },
    {
      name: 'add',
      path: '/display/:cryptext',
      component: Editor,
    },
    {
      name: 'edit',
      path: '/display/edit/:cryptext/:id',
      component: Editor,
    },
    {
      name: 'segment',
      path: '/display/add-edit/segment/:cryptext',
      component: ListSegment,
      props: {
        typeS: "segment"
      },
    },
    {
      name: 'ListSegment',
      path: '/display/list-segment/:cryptext',
      component: ListSegment,
      props: {
        typeS: "segment"
      },
    },
    {
      name: 'EditSegment',
      path: '/display/edit-segment/:id/:cryptext',
      component: EditSegment,
      props: {
        typeS: "segment"
      },
    },
    {
      name: 'AddSegment',
      path: '/display/add-segment/:cryptext',
      component: EditSegment,
    },
    {
      name: 'AddScreenToSegment',
      path: '/display/add-screen/:cryptext',
      component: EditSegment,
    },
    {
      name: 'schedule',
      path: '/display/show-schedule/:id/:cryptext',
      component:Schedule,
    },
    {
      name: 'schedule_by_rmbox',
      path: '/display/show-schedule-by-rmbox/:id',
      component:Schedule,
      props: { isRmBox: true },
    },
    /*{
      name: 'template',
      path: '/display/template/:id/:cryptext',
      component: Template
    }*/
  ],
  mode: 'history',
});



// WEBPACK FOOTER //
// ./src/router/index.js